import React from 'react';
import { useTranslation } from 'react-i18next';
import Carousel from '../components/Carousel';
import ServiceCard from '../components/ServiceCard';

export const whyUsPoints = [
  {
    id: 1,
    title: 'whyUs.supportWhatsApp',
    description: 'whyUs.supportWhatsAppDesc',
    icon: 'fas fa-comments',
  },
  {
    id: 2,
    title: 'whyUs.variousPackages',
    description: 'whyUs.variousPackagesDesc',
    icon: 'fas fa-box-open',
  },
  {
    id: 3,
    title: 'whyUs.transparentPrices',
    description: 'whyUs.transparentPricesDesc',
    icon: 'fas fa-tags',
  },
  {
    id: 4,
    title: 'whyUs.localWorldwideExperience',
    description: 'whyUs.localWorldwideExperienceDesc',
    icon: 'fas fa-globe',
  },
  {
    id: 5,
    title: 'whyUs.supportBeforeDuringAfter',
    description: 'whyUs.supportBeforeDuringAfterDesc',
    icon: 'fas fa-hands-helping',
  },
];
const carouselItems = whyUsPoints.map((point) => ({
  id: point.id,
  content: (
    <ServiceCard
      service={point}
      maxHeight="230px"
      minHeight="230px"
    />
  ),
}));

const AboutPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="py-20">
      <div className="container mx-auto px-6">
        {/* Mission & Vision Section - Reversed for RTL */}
        <div className={`flex flex-col md:flex-row items-center`}>
          {/* Image */}
          <div className="md:w-1/2 mb-10 md:mb-0">
            <img
              src="/assets/images/about.png"
              alt={t('about.imageAlt')}
              className="w-full h-auto md:h-[500px] object-cover rounded-xl shadow-lg"
            />
          </div>

          {/* Text Content */}
          <div className={`md:w-1/2 md:px-5 text-black text-lg`}>
            <div className="mb-2">
              <h1 className={`text-blue-700 font-bold mb-6`}>
                {t('about.title')}
              </h1>
              <p className={`text-2xl font-bold`}>{t('about.subtitle')}</p>
            </div>
            <p className={`mb-8`}>{t('about.missionText')}</p>
            <h2 className={`mb-2 `}>{t('about.vision')}</h2>
            <p>{t('about.vision2')}</p>
          </div>
        </div>

        {/* Why Us Section */}
        <div className="relative mx-auto px-6 mt-12">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-blue-700 mb-8">
            {t('whyUs.title')}
          </h2>
          <Carousel
            items={carouselItems}
            type="service"
            customNavigation={true}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
